import React, { useState } from 'react';
import { Shield, BarChart3, Building2, Users, FileText, Activity, PlusCircle } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import StatsPanel from './platform/StatsPanel';
import OrganizationsPanel from './platform/OrganizationsPanel';
import ProvisionOrgPanel from './platform/ProvisionOrgPanel';
import PlatformUsersPanel from './platform/PlatformUsersPanel';
import AuditPanel from './platform/AuditPanel';
import HealthPanel from './platform/HealthPanel';

const ALL_TABS = [
  { id: 'stats', label: 'Overview', icon: BarChart3, component: StatsPanel, adminOnly: false },
  { id: 'provision', label: 'Provision org', icon: PlusCircle, component: ProvisionOrgPanel, adminOnly: false },
  { id: 'orgs', label: 'Organizations', icon: Building2, component: OrganizationsPanel, adminOnly: false },
  { id: 'users', label: 'Platform users', icon: Users, component: PlatformUsersPanel, adminOnly: true },
  { id: 'audit', label: 'Audit log', icon: FileText, component: AuditPanel, adminOnly: false },
  { id: 'health', label: 'Health', icon: Activity, component: HealthPanel, adminOnly: false },
];

const PlatformAdmin = () => {
  const { isPlatformUser, isPlatformAdmin } = useAuth();
  const tabs = ALL_TABS.filter((t) => isPlatformAdmin() || !t.adminOnly);
  const [activeTab, setActiveTab] = useState('stats');

  if (!isPlatformUser()) {
    return (
      <div className="bg-white dark:bg-slate-900 rounded-xl border border-slate-200/80 dark:border-slate-800 p-8 text-center">
        <Shield className="h-8 w-8 text-slate-400 mx-auto mb-2" />
        <p className="text-[14px] text-slate-600 dark:text-slate-400">Platform access only.</p>
      </div>
    );
  }

  const ActiveComponent = tabs.find((t) => t.id === activeTab)?.component || StatsPanel;

  return (
    <div className="space-y-5">
      <div>
        <div className="flex items-center gap-2">
          <Shield className="h-5 w-5 text-emerald-600" />
          <h1 className="text-[20px] font-semibold text-slate-900 dark:text-slate-100 tracking-tight">Platform</h1>
        </div>
        <p className="text-[13px] text-slate-500 dark:text-slate-400 mt-1">
          Cross-tenant control over every organization on mySMS360.
        </p>
      </div>

      <div className="border-b border-slate-200 dark:border-slate-800">
        <nav className="flex gap-1 -mb-px overflow-x-auto">
          {tabs.map((t) => {
            const Icon = t.icon;
            const active = activeTab === t.id;
            return (
              <button
                key={t.id}
                onClick={() => setActiveTab(t.id)}
                className={`flex items-center gap-1.5 px-4 py-2.5 text-[13px] font-medium border-b-2 transition-colors whitespace-nowrap ${
                  active
                    ? 'border-emerald-600 text-emerald-700 dark:text-emerald-400'
                    : 'border-transparent text-slate-500 dark:text-slate-400 hover:text-slate-900 dark:hover:text-slate-100 hover:border-slate-300 dark:hover:border-slate-700'
                }`}
              >
                <Icon className="h-4 w-4" />
                {t.label}
              </button>
            );
          })}
        </nav>
      </div>

      <ActiveComponent />
    </div>
  );
};

export default PlatformAdmin;
